export enum Installments {
  P = 'P',
  IP3 = 'IP3',
}

export const INSTALLMENT_LENGTHS = {
  [Installments.P]: 1,
  [Installments.IP3]: 3,
};

export type Item = {
  name: string;
  quantity: number;
};

export type Promotion = {
  title: string;
  description: string;
};

export type Price = {
  value: number;
  currencyCode: string;
};

export type TransactionRate = {
  percentage: number;
  fixedAmount: Price;
};

export type TransactionRates = {
  keyedInRate: TransactionRate;
  inPersonRate: TransactionRate;
};

export type Pricing = {
  transactionRates: TransactionRates;
  monthlyPrice: Price;
  additionalDevicePrice: Price;
};

export type Plan = {
  term: Installments;
  price: number;
};

export type Plans = Plan[];
